import { ElectronicsDevice } from '../models/electronics-device';

export const devices: ElectronicsDevice[] = [
    {
        name: 'Smartphone',
        icon: '/assets/icons/devices/icon_handy.svg',
        displayName: 'Smartphone',
        displayNameDative: 'des Smartphones',
        manufacturers: ['Apple', 'Google', 'HUAWEI', 'Motorola', 'Realme', 'Samsung', 'Sony', 'Xiaomi'],
    },
    {
        name: 'Smartwatch',
        icon: '/assets/icons/devices/icon_smartwatch.svg',
        displayName: 'Smartwatch',
        displayNameDative: 'der Smartwatch',
        manufacturers: ['Apple', 'FitBit', 'Garmin', 'HUAWEI', 'Polar', 'Samsung', 'Xplora', 'X-WATCH'],
    },
    {
        name: 'Kamera',
        icon: '/assets/icons/devices/icon_kamera.svg',
        displayName: 'Kamera',
        displayNameDative: 'der Kamera',
        manufacturers: ['Canon', 'Fujifilm', 'GoPro', 'Lamax', 'Nikon', 'Olympus', 'Panasonic', 'Sony'],
    },
    {
        name: 'Notebook',
        icon: '/assets/icons/devices/icon_notebook.svg',
        displayName: 'Notebook',
        displayNameDative: 'des Notebooks',
        manufacturers: ['Acer', 'Apple', 'Asus', 'Dell', 'Fujitsu', 'HP', 'Lenovo', 'Samsung'],
    },
    {
        name: 'Beamer',
        icon: '/assets/icons/devices/icon_beamer.svg',
        displayName: 'Beamer',
        displayNameDative: 'des Beamers',
        manufacturers: ['Acer', 'Asus', 'BenQ', 'Epson', 'NEC', 'Panasonic', 'Philips', 'Viewsonic'],
    },
    {
        name: 'Haushaltsgerät',
        icon: '/assets/icons/devices/icon_haushalt.svg',
        displayName: 'Haushaltsgerät',
        displayNameDative: 'des Haushaltsgerätes',
        manufacturers: ['Waschmaschine', 'Kühlschrank', 'Kochfeld', 'Kaffeemaschine', 'Trockner'],
    },
    {
        name: 'Fernseher',
        icon: '/assets/icons/devices/icon_tv.svg',
        displayName: 'Fernseher',
        displayNameDative: 'des Fernsehers',
        manufacturers: ['Dyon', 'JayTech', 'JTC', 'LG', 'Panasonic', 'Samsung', 'Sony', 'Telefunken'],
    },
    {
        name: 'PC / Monitor',
        icon: '/assets/icons/devices/icon_pc_system.svg',
        displayName: 'PC / Monitor',
        displayNameDative: 'des PCs / Monitors',
        manufacturers: [
            'Acer',
            'Apple',
            'Asus',
            'BenQ',
            'Dell',
            'Fujitsu',
            'HP',
            'Joy it',
            'Lenovo',
            'LG',
            'Samsung',
            'Viewsonic',
        ],
    },
    {
        name: 'Konsole',
        icon: '/assets/icons/devices/icon_controller.svg',
        displayName: 'Konsole',
        displayNameDative: 'der Konsole',
        manufacturers: ['Aerosoft', 'Hama', 'Microsoft', 'Nintendo', 'Sony', 'Steelplay', 'Steelseries', 'Logitech'],
    },
    {
        name: 'VR-Brille',
        icon: '/assets/icons/devices/icon_vr_brille.svg',
        displayName: 'VR-Brille',
        displayNameDative: 'der VR-Brille',
        manufacturers: ['Basetech', 'Celexon', 'HP', 'HTC', 'Renkforce'],
    },
    {
        name: 'Kopfhörer',
        icon: '/assets/icons/devices/icon_kopfhoerer.svg',
        displayName: 'Kopfhörer',
        displayNameDative: 'des Kopfhörers',
        manufacturers: ['AKG', 'Apple', 'Beats', 'Hama', 'JBL', 'Logitech', 'Sennheiser', 'Sony'],
    },
    {
        name: 'Tablet',
        icon: '/assets/icons/devices/icon_tablet.svg',
        displayName: 'Tablet',
        displayNameDative: 'des Tablets',
        manufacturers: ['Acer', 'Apple', 'Hannspree', 'HUAWEI', 'Lenovo', 'Microsoft', 'Odys', 'Samsung'],
    },
];

export const lensManufacturers: string[] = [
    'Canon',
    'Sony',
    'Olympus',
    'Walimex',
    'Samyang',
    'Nikon',
    'Fujifilm',
    'Panasonic',
];
